<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="is_loading"
      hide-default-footer
      disable-pagination
      disable-sort
      class="elevation-1"
    >
      <template v-slot:item.language="{ item }">
        {{ getLanguageName(item.language) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="editTranslation(item)"
              :loading="btn_loading"
              :disabled="btn_loading"
            >
              <v-icon small>mdi-upload</v-icon>
            </v-btn>
          </template>
          <span>Upload Translation</span>
        </v-tooltip>

        <v-tooltip bottom v-if="item.po_exists">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="success"
              v-bind="attrs"
              v-on="on"
              @click="downloadTranslation(item)"
              :loading="btn_loading"
              :disabled="!item.po_exists || btn_loading"
            >
              <v-icon small>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Download Translation</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { requestStatus, languages } from "@/services/services";
import {
  getOfferTranslations,
  downloadOfferTranslation,
  uploadTranslation,
} from "@/store/modules/offers/api";
export default {
  name: "Translations",
  props: {
    offer: Object,
  },
  data() {
    return {
      is_loading: false,
      btn_loading: false,
      list: [],
      headers: [
        {
          text: "Language",
          value: "language",
          align: "start",
        },

        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.loadTranslations();
  },
  mounted() {
    window.getApp.$on("UPDATE_TRANSLATION_LIST", () => {
      this.loadTranslations();
    });
  },
  destroyed() {
    window.getApp.$off("UPDATE_TRANSLATION_LIST");
  },
  methods: {
    loadTranslations() {
      this.is_loading = true;
      getOfferTranslations(this.offer.short_key)
        .then((response) => {
          if (response.status === requestStatus.success) {
            this.list = response.response.data.results;
          } else {
            // this.list = [
            //   { language: "en", po_exists: true, mo_exists: true },
            //   { language: "fr", po_exists: true, mo_exists: false },
            //   { language: "de", po_exists: false, mo_exists: false },
            //   { language: "es", po_exists: true, mo_exists: true },
            //   { language: "uk", po_exists: false, mo_exists: false },
            // ];
            this.$toaster.error(
              response.messages || "Oops, something went wrong."
            );
          }
        })
        .catch(() => {
          this.$toaster.error("Oops, something went wrong.");
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getLanguageName(languageCode) {
      return (
        languages.find((lang) => lang.value === languageCode)?.label ||
        languageCode.toUpperCase()
      );
    },

    editTranslation(item) {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "";

      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          this.uploadTranslationFile(item, file);
        }
      };

      input.click();
    },
    uploadTranslationFile(item, file) {
      this.btn_loading = true;

      const processedFile = new File([file], encodeURIComponent(file.name), {
        type: file.type,
      });

      uploadTranslation(processedFile, this.offer.short_key, item.language)
        .then((response) => {
          if (response.status == requestStatus.success) {
            this.$toaster.success(
              `Translation uploaded for ${this.getLanguageName(item.language)}`
            );
            this.loadTranslations();
          } else {
            this.$toaster.error(
              response.messages || "Failed to upload translation"
            );
          }
        })
        .catch((error) => {
          this.$toaster.error("Failed to upload translation");
          console.error("Upload error:", error);
        })
        .finally(() => {
          this.btn_loading = false;
        });
    },
    downloadTranslation(item) {
      this.btn_loading = true;
      downloadOfferTranslation(this.offer.short_key, item.language)
        .then((response) => {
          let filename = `messages_${item.language}.po`;

          const contentDisposition =
            response.response.headers["content-disposition"];
          if (contentDisposition) {
            const match = contentDisposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            );
            if (match && match[1]) {
              filename = match[1].replace(/['"]/g, "");
            }
          }

          let url = window.URL.createObjectURL(
            new Blob([response.response.data], {
              type:
                response.response.headers["content-type"] ||
                "application/octet-stream",
            })
          );
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.$toaster.error("Failed to download translation");
          console.error("Download error:", error);
        })
        .finally(() => {
          this.btn_loading = false;
        });
    },
  },
};
</script>
